import React from 'react'
import Header from '../components/global/Header'
import Footer from '../components/global/Footer'
import card from "../assets/images/card.png"
import pcm from "../assets/images/pcm.png"
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { ArrowLeftOutlined } from "@ant-design/icons"
import { Link } from "react-router-dom"

function Billing() {
  return (
    <div>
      <Header />
      <div className="container ">
        <p>Billing Info</p>
        <div className="row">
          <div className="col-lg-8">
            <div className="col-12 billinginfo">
              <p>Credit Card Info</p>
              <div className="creditcard" >
                <img src={card} alt="" />
                <input type="text" placeholder="Card Number" name="" id="" />
                <input style={{ width: '100px', float: 'right' }} type="text" placeholder="MM/YY" name="" id="" />
                <input style={{ width: '100px', float: 'right' }} type="text" placeholder="CCV" name="" id="" />
              </div>
              <button className="button">Update Billing Details <span><ExpandLessIcon /></span></button>
              <div className="col-12">
                <div className="col-md-6">
                  <label>Email</label>
                  <input type="text" name="" id="" />
                </div>
                <div className="col-md-6">
                  <label>Email</label>
                  <input type="text" name="" id="" />
                </div>
              </div>


            </div>
          </div>
          <div className="col-lg-4">
            <div className="col-12 billing">
              <p>Order Summary</p>
              <table className="table table-borderless">
                <tbody>
                  <tr>

                    <td style={{ display: 'flex', alignItems: 'center' }}>  <img src={pcm} alt="" srcset="" /> 1 x Paracetamol 500mg</td>
                    <td>₦1,570</td>
                  </tr>
                  <tr>
                    <td>Item(s) Total</td>
                    <td className="price">₦1,570</td>
                  </tr>
                  <tr>
                    <td> VAT(21%)</td>
                    <td className="price">₦1,570</td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div className="Payment">
              <div>
                <p>Total Price</p>
                <p>₦1,570</p>
              </div>

              <button>Pay</button>
            </div>
            <hr />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Link to="/cart-details">
                <ArrowLeftOutlined style={{ fontSize: '24px', color: 'black' }} />
              </Link>
              <p style={{ color: '#3F1497' }}>MODIFY CART</p>
            </div>

          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Billing